export default "__VITE_ASSET__C6MY$GSR__"